//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'Cpts001',
        props: {
            data: Object,
            index: Number,
            strategyId: String
        },
        data () {
            return {
                handleText: '更多',
                handleShow: false,
                briefIntercept: false
            }
        },
        mounted () {
            if (this.$refs.brief && this.$refs.brief.clientHeight > 144) {
                this.handleShow = true
                this.briefIntercept = true
            }
        },
        methods: {
            openBrief: function () {
                if (this.briefIntercept) {
                    this.handleText = '收起'
                    this.briefIntercept = false
                } else {
                    this.handleText = '更多'
                    this.briefIntercept = true
                }
            }
        }
    }
